/* theme.js — elybear Shopify theme: AJAX cart drawer + free-delivery bar, search panel,
 * Black Friday countdown, product variant picker, collection sort, GIF/video playback.
 * Runs before motion.js (both deferred). Re-initialises sections reloaded in the theme editor. */
(function () {
  "use strict";
  var doc = document, T = window.theme || {}, S = T.strings || {};
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = T.moneyFormat || "€{{amount}}";
    function f(n, d, ts, ds) { var p = (n / 100).toFixed(d).split("."); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return p[0] + (p[1] ? ds + p[1] : ""); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === "amount_no_decimals") return f(cents, 0, ",", ".");
      if (k === "amount_with_comma_separator") return f(cents, 2, ".", ",");
      if (k === "amount_no_decimals_with_comma_separator") return f(cents, 0, ".", ",");
      if (k === "amount_with_space_separator") return f(cents, 2, " ", ",");
      return f(cents, 2, ",", ".");
    }).replace(/<[^>]+>/g, "");
  }

  /* =================== CART =================== */
  var R = T.routes || {};
  function api(url, body) {
    return fetch(url, body ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) } : { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function img(url, w) { if (!url) return ""; return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + (w || 160); }

  function renderCart(c, bump) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = c.item_count; el.hidden = !c.item_count;
      if (bump) { el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump"); }
    });
    $$("[data-cart-total]").forEach(function (el) { el.textContent = money(c.total_price); });
    $$("[data-cart-hide-empty]").forEach(function (el) { el.hidden = !c.item_count; });
    $$("[data-cart-show-empty]").forEach(function (el) { el.hidden = !!c.item_count; });
    var goal = +T.freeShipping || 0, left = goal - c.total_price;
    $$("[data-ship-bar]").forEach(function (el) {
      el.hidden = !c.item_count || !goal;
      el.innerHTML = (left > 0 ? esc(S.shipLeft || "").replace("{amount}", "<b>" + money(left) + "</b>") : "<b>" + esc(S.shipDone) + "</b>") +
        '<div class="bar"><i style="--p:' + Math.min(1, c.total_price / (goal || 1)).toFixed(3) + '"></i></div>';
    });
    $$("[data-cart-items]").forEach(function (box) {
      box.innerHTML = c.items.length ? c.items.map(function (it) {
        var vt = it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : "";
        return '<div class="ci"><a href="' + esc(it.url) + '"><img src="' + esc(img(it.image, 180)) + '" alt="" width="68" height="68" loading="lazy"></a><div><b>' + esc(it.product_title) + "</b>" +
          "<small>" + (vt ? esc(vt) + " · " : "") + money(it.final_line_price) + "</small></div>" +
          '<div class="qty"><button type="button" data-qty-key="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="-">−</button><span>' + it.quantity +
          '</span><button type="button" data-qty-key="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="+">+</button></div></div>';
      }).join("") : '<p class="empty">' + esc(S.empty) + "</p>";
    });
  }
  function refreshCart(bump) { return api(R.cartJs).then(function (c) { renderCart(c, bump); return c; }); }

  function setOpen(open) {
    doc.body.classList.toggle("cart-open", open);
    var d = $("[data-cart-drawer]");
    if (d) d.setAttribute("aria-hidden", open ? "false" : "true");
  }
  function fly(from) {
    var target = $$("[data-cart-open]").filter(function (b) { return b.offsetParent; })[0];
    if (!from || !target || reduce) return;
    var a = from.getBoundingClientRect(), b = target.getBoundingClientRect(); if (!a.width) return;
    var g = from.cloneNode(); g.removeAttribute("srcset"); g.removeAttribute("sizes"); g.className = "";
    g.style.cssText = "position:fixed;z-index:999;pointer-events:none;object-fit:contain;left:" + a.left + "px;top:" + a.top + "px;width:" + a.width + "px;height:" + a.height + "px;transition:transform .75s cubic-bezier(.5,-0.2,.3,1),opacity .75s";
    doc.body.appendChild(g);
    requestAnimationFrame(function () {
      g.style.transform = "translate(" + (b.left + b.width / 2 - a.left - a.width / 2) + "px," + (b.top + b.height / 2 - a.top - a.height / 2) + "px) scale(.08)"; g.style.opacity = ".3";
    });
    setTimeout(function () { g.remove(); }, 800);
  }
  var toastEl, toastT;
  function toast(item) {
    if (!toastEl) { toastEl = doc.createElement("div"); toastEl.className = "toast"; toastEl.setAttribute("role", "status"); doc.body.appendChild(toastEl); }
    toastEl.innerHTML = '<svg viewBox="0 0 24 24" width="18" fill="none" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg><span>' + esc(item.product_title) + " — " + esc(S.added) + "</span>";
    toastEl.classList.add("on");
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove("on"); }, 2400);
  }
  function addToCart(id, qty, srcImg, then, items) {
    return api(R.cartAdd, { items: items || [{ id: +id, quantity: qty || 1 }] }).then(function (res) {
      var item = res.items ? res.items[0] : res;
      if (then === "checkout") { location.href = "/checkout"; return; }
      fly(srcImg); toast(item); refreshCart(true);
      if (window.fbq) fbq("track", "AddToCart", { content_ids: [String(id)], content_type: "product" });
    }).catch(function (e) { alert((e && (e.description || e.message)) || S.unavailable); });
  }

  doc.addEventListener("click", function (e) {
    var t = e.target.closest("[data-add],[data-qty-key],[data-cart-open],[data-cart-close],[data-search-open],[data-search-close]"); if (!t) return;
    if (t.hasAttribute("data-add")) {
      e.preventDefault(); if (t.disabled) return;
      addToCart(t.getAttribute("data-add"), 1, $(".pc-media img, .spot-media img", t.closest(".pc, .spot") || doc));
      t.classList.remove("done"); void t.offsetWidth; t.classList.add("done");
    } else if (t.hasAttribute("data-qty-key")) {
      api(R.cartChange, { id: t.getAttribute("data-qty-key"), quantity: Math.max(0, +t.getAttribute("data-q")) }).then(function (c) {
        renderCart(c, true);
        if (doc.body.classList.contains("template-cart")) location.reload();
      });
    } else if (t.hasAttribute("data-cart-open")) {
      if (doc.body.classList.contains("template-cart")) return;
      e.preventDefault(); doc.body.classList.remove("search-open"); setOpen(true); refreshCart(false);
    } else if (t.hasAttribute("data-search-open")) {
      doc.body.classList.add("search-open"); setTimeout(function () { var i = $(".search input[type=search]"); if (i) i.focus(); }, 200);
    } else { doc.body.classList.remove("search-open"); setOpen(false); }
  });
  addEventListener("keydown", function (e) { if (e.key === "Escape") { setOpen(false); doc.body.classList.remove("search-open"); } });

  // product forms: AJAX add; "buy now" goes straight to checkout
  doc.addEventListener("submit", function (e) {
    var f = e.target; if (!f.matches || !f.matches("form[data-product-form]")) return;
    e.preventDefault();
    var sub = e.submitter, id = f.elements.id.value, q = +(f.elements.quantity || { value: 1 }).value || 1;
    if (sub && sub.disabled) return;
    var items = null, bundle = $("[data-bundle]");
    if (bundle) { // Bundle & Save: selected tier, one colour per item
      var opt = $(".bundle-opt.sel", bundle) || $(".bundle-opt", bundle), n = +$("input", opt).value || 1, picks = $$("select[data-b-pick]", opt), map = {};
      if (picks.length) picks.forEach(function (p) { map[p.value] = (map[p.value] || 0) + 1; });
      else map[id] = n;
      items = Object.keys(map).map(function (k) { return { id: +k, quantity: map[k] }; });
    }
    addToCart(id, q, $(".pp-main img:last-of-type"), sub && sub.hasAttribute("data-buy-now") ? "checkout" : null, items);
  });
  refreshCart(false).catch(function () {});

  /* =================== COMPONENTS (re-run per section in the editor) =================== */
  // Black Friday countdown: before start → "starts in", during → "ends in", after → hidden.
  // Sets data-countdown before motion.js reads it.
  function initCountdown(root) {
    $$("[data-bf-countdown]", root).forEach(function (el) {
      var now = Date.now(), start = new Date(el.getAttribute("data-start")).getTime(), end = new Date(el.getAttribute("data-end")).getTime(), label = $(".cd-label", el);
      if (isNaN(end)) { el.hidden = true; return; }
      if (!isNaN(start) && now < start) { el.setAttribute("data-countdown", el.getAttribute("data-start")); if (label) label.textContent = S.bfStarts; }
      else if (now < end) { el.setAttribute("data-countdown", el.getAttribute("data-end")); if (label) label.textContent = S.bfEnds; }
      else el.hidden = true;
    });
  }

  function initProduct(root) {
    $$("[data-pp]", root).forEach(function (pp) {
      if (pp._init) return; pp._init = true;
      var P; try { P = JSON.parse($("script[data-product-json]", pp).textContent); } catch (e) { return; }
      var form = doc.getElementById("product-form"), idIn = form && form.elements.id, qIn = form && form.elements.quantity;
      var main = $(".pp-main", pp), thumbs = $(".thumbs", pp);
      var cur = P.variants.filter(function (v) { return v.id === +(idIn && idIn.value); })[0] || P.variants[0];
      var sel = cur.options.slice();
      function norm(u) { return String(u || "").replace(/^https?:/, "").split("?")[0]; }
      function show(src) {
        if (!src || !main) return;
        src = norm(src);
        var last = $("img:last-of-type", main); if (last && norm(last.getAttribute("data-src") || last.currentSrc || last.src) === src) return;
        var im = new Image(); im.src = src + "?width=1200"; im.setAttribute("data-src", src); im.alt = P.title;
        $$("img", main).forEach(function (o) { o.remove(); }); main.appendChild(im);
        $$("button", thumbs).forEach(function (b) { b.classList.toggle("on", norm(b.getAttribute("data-src")) === src); });
      }
      if (thumbs) thumbs.addEventListener("click", function (e) { var b = e.target.closest("button"); if (b) show(b.getAttribute("data-src")); });
      function find() { return P.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0]; }
      function sync(first) {
        var v = find();
        $$("[data-opt]", pp).forEach(function (b) { var i = +b.getAttribute("data-opt"); b.setAttribute("aria-checked", b.getAttribute("data-value") === sel[i] ? "true" : "false"); });
        $$("[data-opt-name]", pp).forEach(function (el) { el.textContent = sel[+el.getAttribute("data-opt-name")] + (v && !v.available ? " — " + S.soldOut : ""); });
        $$("[data-buy]").forEach(function (b) {
          b.disabled = !v || !v.available;
          if (b.hasAttribute("data-label-add")) ($("[data-buy-label]", b) || b).textContent = !v ? S.unavailable : v.available ? b.getAttribute("data-label-add") : S.soldOut;
        });
        var note = $(".oos-note", pp); if (note) note.hidden = !!(v && v.available);
        if (!v) return;
        cur = v; if (idIn) idIn.value = v.id;
        var q = qIn ? +qIn.value || 1 : 1, deal = v.compare_at_price > v.price;
        $$("[data-price]", pp).forEach(function (el) { el.textContent = money(v.price); });
        $$("[data-compare]", pp).forEach(function (el) { el.textContent = deal ? money(v.compare_at_price) : ""; el.hidden = !deal; });
        $$("[data-save]", pp).forEach(function (el) { el.hidden = !deal; });
        $$("[data-save-amount]", pp).forEach(function (el) { el.textContent = deal ? money(v.compare_at_price - v.price) : ""; });
        $$("[data-off]", pp).forEach(function (el) { var o = deal ? Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0; el.textContent = o ? "−" + o + "%" : ""; el.hidden = !o; });
        $$("[data-sticky-price]").forEach(function (el) { el.textContent = money(v.price * q); });
        if (!first && v.featured_image) show(v.featured_image.src);
        if (!first && history.replaceState) history.replaceState(null, "", location.pathname + "?variant=" + v.id);
      }
      pp.addEventListener("click", function (e) {
        var b = e.target.closest("[data-opt]");
        if (b) { sel[+b.getAttribute("data-opt")] = b.getAttribute("data-value"); sync(); return; }
        var s = e.target.closest("[data-qty-step]");
        if (s && qIn) { qIn.value = Math.max(1, Math.min(99, (+qIn.value || 1) + +s.getAttribute("data-qty-step"))); $$("[data-qty-out]", pp).forEach(function (o) { o.textContent = qIn.value; }); sync(true); }
      });
      $$("select[data-opt-select]", pp).forEach(function (s) { s.addEventListener("change", function () { sel[+s.getAttribute("data-opt-select")] = s.value; sync(); }); });
      sync(true);
    });
  }

  function initCollection(root) {
    $$("select[data-sort-by]", root).forEach(function (s) {
      s.addEventListener("change", function () { var u = new URL(location.href); u.searchParams.set("sort_by", s.value); u.searchParams.delete("page"); location.href = u.toString(); });
    });
  }

  // play GIF-videos only while on screen (battery + data on phones)
  function initVideos(root) {
    if (!("IntersectionObserver" in window)) return;
    $$(".show-media video, .gal-item video, .iwt-media video, .ugc video", root).forEach(function (v) {
      if (v._io) return; v.muted = true;
      v._io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { var p = v.play(); if (p) p.catch(function () {}); } else v.pause(); }); });
      v._io.observe(v);
    });
  }

  function initBundle(root) {
    $$("[data-bundle]", root).forEach(function (b) {
      if (b._init) return; b._init = true;
      b.addEventListener("change", function (e) {
        if (e.target.name !== "bundle-qty") return;
        $$(".bundle-opt", b).forEach(function (o) { o.classList.toggle("sel", $("input", o).checked); });
      });
      // a colour select inside a tier also selects that tier
      b.addEventListener("click", function (e) { var o = e.target.closest(".bundle-opt"); if (o && e.target.closest("select")) { $("input", o).checked = true; $$(".bundle-opt", b).forEach(function (x) { x.classList.toggle("sel", x === o); }); } });
    });
  }


  // delivery timeline: business days from today, in the shopper's own time zone
  function initShip(root) {
    $$("[data-ship]", root).forEach(function (el) {
      var loc = el.getAttribute("data-locale") || undefined, fmt;
      try { fmt = new Intl.DateTimeFormat(loc, { day: "numeric", month: "short" }); } catch (e) { fmt = new Intl.DateTimeFormat(undefined, { day: "numeric", month: "short" }); }
      function add(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
      var out = +el.getAttribute("data-out") || 0, mn = +el.getAttribute("data-min") || 1, mx = Math.max(mn, +el.getAttribute("data-max") || mn);
      var t = [fmt.format(new Date()), fmt.format(add(out)), fmt.format(add(mn)) + " – " + fmt.format(add(mx))];
      $$("[data-ship-d]", el).forEach(function (b) { b.textContent = t[+b.getAttribute("data-ship-d")]; });
    });
  }

  // scroll-snap sliders with dots (mini reviews, testimonials on phones)
  function initDots(root) {
    $$("[data-rev-track]", root).forEach(function (track) {
      if (track._init) return; track._init = true;
      var dots = track.parentNode.querySelector("[data-rev-dots]"), items = track.children, n = items.length;
      if (!dots || n < 2) return;
      dots.innerHTML = "";
      for (var i = 0; i < n; i++) { var b = doc.createElement("button"); b.type = "button"; b.setAttribute("aria-label", i + 1); (function (k) { b.addEventListener("click", function () { track.scrollTo({ left: items[k].offsetLeft - track.offsetLeft, behavior: "smooth" }); }); })(i); dots.appendChild(b); }
      function cur() { var k = Math.round(track.scrollLeft / Math.max(1, items[0].offsetWidth)); $$("button", dots).forEach(function (b, j) { b.classList.toggle("on", j === Math.min(n - 1, Math.abs(k))); }); }
      track.addEventListener("scroll", function () { requestAnimationFrame(cur); }, { passive: true }); cur();
      if (track.hasAttribute("data-auto") && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
        var k = 0; setInterval(function () { if (track.matches(":hover")) return; k = (Math.round(track.scrollLeft / Math.max(1, items[0].offsetWidth)) + 1) % n; track.scrollTo({ left: items[k].offsetLeft - track.offsetLeft, behavior: "smooth" }); }, 5000);
      }
    });
  }

  // before / after slider
  function initCompare(root) {
    $$("[data-ba]", root).forEach(function (ba) {
      if (ba._init) return; ba._init = true;
      var r = $("input[type=range]", ba);
      function set() { ba.style.setProperty("--pos", r.value + "%"); }
      r.addEventListener("input", set); set();
    });
  }

  function init(root) { initCountdown(root); initProduct(root); initBundle(root); initCollection(root); initVideos(root); initShip(root); initDots(root); initCompare(root); }
  init(doc);

  /* theme editor: sections are re-rendered without a page load */
  doc.addEventListener("shopify:section:load", function (e) {
    var s = e.target;
    $$("[data-reveal]", s).forEach(function (el) { el.classList.add("in"); });
    $$("[data-bar]", s).forEach(function (el) { el.style.setProperty("--w", el.getAttribute("data-bar") + "%"); });
    init(s);
  });
  doc.addEventListener("shopify:block:select", function (e) { var d = e.target.closest("details"); if (d) d.open = true; });
  window.ElybearTheme = { money: money, refreshCart: refreshCart, openCart: setOpen, addToCart: addToCart };
})();
